module.exports = __webpack_public_path__ + "static/media/wedding_help@2x.b4563329.png";


/*****************
 ** WEBPACK FOOTER
 ** ./public/images/doodles/wedding_help@2x.png
 ** module id = 2136
 ** module chunks = 44
 **/